import Cookies from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';
import { SplitIO } from 'types';

const cookies = new Cookies();

const getSplitUserId = (): string => {
  const splitUserId = cookies.get<string | null>(SplitIO.Cookie.SPLIT_USER_ID);

  if (!splitUserId) {
    const generatedId = uuidv4();
    cookies.set(SplitIO.Cookie.SPLIT_USER_ID, generatedId, {
      maxAge: 31536000, // 1 year from today
      secure: true,
      path: '/',
      sameSite: 'strict',
    });

    return generatedId;
  }

  return splitUserId;
};

export default getSplitUserId;
